import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import IntegrationCard from '../../../components/IntegrationCard/IntegrationCard';
import SetupStepCard from '../../../components/SetupStepCard/SetupStepCard';
import { Button } from '../../../design-system';

import EditApiKeyModal from '../../../pages/OrganizationPage/EditApiKeyModal/EditApiKeyModal';

import * as API from '../../../constants/api';
import { usePostRequest } from '../../../hooks/request';
import externalClient from '../../../services/external-api';

const MakeSetup2Page = () => {
    const [editApiKeyModal, setEditApiKeyModal] = useState({
        opened: false,
        data: null,
        mode: 'create',
    });

    const apiKeyCreate = usePostRequest({ url: API.ROUTES.apikey.apikey }, externalClient);

    const navigate = useNavigate();
    const handleDoneClick = () => {
        navigate('/integrations/make/prompt-setup');
    };

    const openCreateAPIKeyModal = () => {
        setEditApiKeyModal({ opened: true });
    };

    return (
        <div className="w-full max-sm:p-4 flex flex-col gap-3 sm:gap-5">
            <IntegrationCard
                title="Use your Promptfolio in a Make Automation"
                description="Access your Promptfolio directly from your Make automations"
                centeredContent
            />
            <div className="w-full py-[30px] sm:py-[80px] flex flex-col gap-[40px] sm:gap-[60px]">
                <SetupStepCard
                    title="Step 1: Search Promptfolio in your apps"
                    image={'/images/make-screenshot-promtfolio-in-apps.png'}
                    imageAlt="Screenshot Search Promptfolio in your apps"
                    description="Don’t see it?"
                    descriptionLink={{
                        text: 'Request an invite.',
                        href: '/integrations/make/setup-1',
                    }}
                />
                <SetupStepCard
                    title="Step 2: Select or create a connection"
                    subtitle="Click ‘Create a Connection’."
                    image={'/images/make-screenshot-create-connection.png'}
                    imageAlt="Screenshot select or create a connection"
                    description="Create an API Key below and input it in Make to set up the connection."
                    additionalDescription="Don’t worry, you can manage these in your settings later."
                    actionButton={{
                        text: 'Create a Promptfolio API Key',
                        handleClick: openCreateAPIKeyModal,
                    }}
                />
                <div className="mx-auto">
                    <Button
                        type="secondary"
                        size="md"
                        text={'I’m Done!'}
                        onClick={handleDoneClick}
                    />
                </div>
            </div>
            {editApiKeyModal.opened && (
                <EditApiKeyModal
                    data={editApiKeyModal.data}
                    onClose={() =>
                        setEditApiKeyModal({
                            opened: false,
                            data: null,
                            mode: 'create',
                        })
                    }
                    apiKeyCreate={apiKeyCreate}
                    handleSave={() => {}}
                    mode={editApiKeyModal.mode}
                />
            )}
        </div>
    );
};

export default MakeSetup2Page;
